module.exports = __webpack_public_path__ + "static/ball_3-fe7717871b97cdf6959bfc5510813f19.png";